import service from './service.js';

export class ValidateService {
    uploadFileToServer(signedDocument, signedDocumentName, originalDocument, originalDocumentName, signedFileUniqueId, originalFileUniqueId, captchaResponse) {
        //returns Promise object
        return service.getRestClient(captchaResponse).post('/api/validate', JSON.stringify(
            {
                base64Document: signedDocument,
                base64DocumentName: signedDocumentName,
                base64Original: originalDocument,
                base64OriginalName: originalDocumentName,
                signedFileUniqueId: signedFileUniqueId,
                originalFileUniqueId: originalFileUniqueId
            }
        ));
    }
}

export default (new ValidateService());